// extracted by mini-css-extract-plugin
module.exports = {"account-setting":"IEfS6Ho8qK"};